import { initializeApp } from "firebase/app";
import {getFirestore} from '@firebase/firestore'
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDX31uS9nyAgf2jj32fzH23yfrq0ie1m6k",
  authDomain: "washmartindia-demo.firebaseapp.com",
  projectId: "washmartindia-demo",
  storageBucket: "washmartindia-demo.appspot.com",
  messagingSenderId: "209586539105",
  appId: "1:209586539105:web:9d5c5b7ff45be65875f820"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const firestore =getFirestore(app);
export const auth = getAuth(app);